import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Rafraîchissement transparent de la session : si le jeton d'accès (2 h) a expiré
// mais que le jeton de rafraîchissement (7 j) est valide, on renouvelle sans déconnecter.
let refreshPromise = null;

async function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API}/auth/refresh`, null, { withCredentials: true })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config || {};
    const isAuthCall = (config.url || "").startsWith("/auth/");
    if (error.response?.status === 401 && !isAuthCall && !config._retried) {
      config._retried = true;
      try {
        await refreshSession();
        return api(config);
      } catch {
        // session réellement expirée → l'utilisateur sera redirigé vers la connexion
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtEuros(cents) {
  return ((cents || 0) / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
}

export const STATUS_COLORS = {
  DRAFT: "bg-amber-100 text-amber-800 border-amber-300",
  SUBMITTED: "bg-sky-100 text-sky-800 border-sky-300",
  PENDING_APPROVAL: "bg-sky-100 text-sky-800 border-sky-300",
  APPROVED: "bg-green-100 text-green-800 border-green-300",
  PARTIALLY_APPROVED: "bg-orange-100 text-orange-800 border-orange-300",
  REJECTED: "bg-red-100 text-red-800 border-red-300",
  CONTESTED: "bg-orange-100 text-orange-900 border-orange-400",
  BISHOP_ARBITRATION: "bg-orange-100 text-orange-900 border-orange-400",
  ARBITRATION_APPROVED: "bg-green-100 text-green-800 border-green-300",
  ARBITRATION_PARTIAL: "bg-orange-100 text-orange-800 border-orange-300",
  ARBITRATION_REJECTED: "bg-red-100 text-red-800 border-red-300",
  ACCOUNTING_PROCESSING: "bg-sky-100 text-sky-800 border-sky-300",
  ACCOUNTED: "bg-teal-100 text-teal-800 border-teal-300",
  PAYMENT_PENDING: "bg-teal-100 text-teal-800 border-teal-300",
  PAID: "bg-green-100 text-green-900 border-green-400",
  ABANDONED: "bg-rose-100 text-rose-800 border-rose-300",
  CLOSED: "bg-slate-100 text-slate-700 border-slate-300",
  ARCHIVED: "bg-slate-100 text-slate-600 border-slate-300",
};

export function StatusBadge({ status, label }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-3 py-1 rounded-full border text-sm font-semibold ${STATUS_COLORS[status] || "bg-slate-100 text-slate-700 border-slate-300"}`}
    >
      {label || status}
    </span>
  );
}
